export const WEATHER_SUCCESS = 'WEATHER_SUCCESS';
export const WEATHER_FAILURE = 'WEATHER_FAILURE';
export const NEXT = 'NEXT';
export const PREVIOUS = 'PREVIOUS';
export const RESET = 'RESET'